import React, {Component} from 'react';
import PropTypes from 'prop-types'
import $ from 'jquery';
import 'fullcalendar';
import '../../../assets/css/fullcalendar.min.css'
import FullCalendar from 'fullcalendar-reactwrapper';
import {Link} from 'react-router-dom'
import Modal from 'react-modal'
import {MONTH,currency_symbol, URL_VERSION} from "../../../server/constants";
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import Datetime from 'react-datetime'
import {postWithHeaders,postWithHeadersResponse} from '../../../server/actions'
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import {formatDate} from '../../../server/util'

let converter = require('number-to-words');

let userInfo = '';
let mealMenu = {};
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
};


class BreakfastCalender extends Component {
    componentWillMount = () => {
        //  alert(JSON.stringify(this.props.meals,null,2))
        userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        //alert(userInfo.schoolName)
        try {
            this.props.meals.mealMenuItems.forEach(event => {

                if (event.type === "SIDE") {
                    event.start = event.start.addHours(1);

                }
            });
            this.setState({meals: this.props.meals.mealMenuItems});
            console.log(this.props.meals)
        } catch (err) {
            console.log("No meals for this month", +err)
        }
    }
   


    constructor() {
        super();
        this.state = {
            meals: [],
            loading: false,
            modalIsOpen: false,
        }
        this.updateEvents = this.updateEvents.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
    }

    componentDidMount() {
       // this.updateEvents(this.state.meals);
        this._notificationSystem = this.refs.notificationSystem;

    }

    componentDidUpdate() {
        //this.updateEvents(this.state.meals);
    }

    updateEvents(eventsList) {
        //console.log(eventsList);
        $('#calendar').fullCalendar('destroy');
        $('#calendar').fullCalendar({
            defaultDate: new Date(this.props.date.year, this.props.date.month - 1, 1),
            themeSystem: 'bootstrap3',
            disableDragging: true,
            height: 'auto',
            header: false,
            weekends: false,
            events: eventsList,
            displayEventTime: false,
            editable: false,
            fixedWeekCount: false,
            droppable: false, // this allows things to be dropped onto the calendar
            eventRender: function (event, element, view) {
                var dataHoje = new Date();
                if (event.type === "MEAL") {                    
                    return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                        'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                        + event.title + "  " + currency_symbol() + event.price + '</div>');
                    //event.color = "#FFB347"; //Em andamento
                }
                else if (event.type === "SIDE") {
                    event.start = event.start + (1 * 60 * 60 * 1000);
                    element.css('background-color', 'inherit');
                    element.css('border', '0px');
                    element.css('font-weight', 'bolder');
                    element.css('white-space', 'pre-wrap');
                    element.css('color', 'red');
                    element.css('font-size', '12px');
                    element.css(' margin-bottom', '-5px');
                }
            },
        })
    }
    eventRender(event, element, view) {
        var dataHoje = new Date();
        if (event.type === "MEAL") {                    
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                + event.title + "  " + currency_symbol() + event.price + '</div>');
            //event.color = "#FFB347"; //Em andamento
        }
        else if (event.type === "SIDE") {
            event.start = event.start + (1 * 60 * 60 * 1000);
            element.css('background-color', 'inherit');
            element.css('border', '0px');
            element.css('font-weight', 'bolder');
            element.css('white-space', 'pre-wrap');
            element.css('color', 'red');
            element.css('font-size', '12px');
            element.css(' margin-bottom', '-5px');
        }
    }

    _addNotification(event) {
        this._notificationSystem.addNotification({
            title: "Success",
            message: event,
            level: 'success',
            position: 'tc',
            autoDismiss: '3',
            uid: 5,

        });
    }

    _addNotificationError(event) {
        this._notificationSystem.addNotification({
            title: "Failed",
            message: event,
            level: 'error',
            position: 'tc',
            autoDismiss: '3',
            uid: 5,
        });
    }

    handleCreate() {
        this.setState({
            loading: true,
            modalIsOpen: false
        })
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let username = userInfo.username;
        mealMenu.loggedUser = username;
        let grades = [];
        this.props.selectedGrades.map(grade => {
            //alert(grade);
            grades.push(grade);
        })
        //alert(grades)
        mealMenu.gradesList = grades;
        mealMenu.mealSchoolId = sessionStorage.getItem('SchoolId');
        mealMenu.yearMonth = "" + this.props.date.year + (('0' + (this.props.date.month)).slice(-2));
        mealMenu.mealMenus = [];        
        this.state.meals.forEach(mealItem => {
            let item = {...mealItem};
            delete item.id;
            delete item.end;            
            //item.itemDesc=item.desc;
            //item.itemType=item.type;
            //item.itemName=item.title
            if (item.type !== "HOLIDAY") {
                item.mealImage = "";
                
                item.start = formatDate(new Date(item.start));
                mealMenu.mealMenus.push(item)
            } else {
                delete item.price;
                item.start = formatDate(new Date(item.start));
                mealMenu.mealMenus.push(item)
            }
        });
        if(this.props.recId>0){
            mealMenu.schoolMealSummaryId=this.props.recId;
        }
        mealMenu.reducedPriceStatus=this.props.meals.reducedPriceStatus;
        console.log(JSON.stringify(mealMenu, null, 2));
        // alert(JSON.stringify(mealMenu, null, 2));

        let headers = {
            'Content-Type': 'application/json'
        }        
        postWithHeadersResponse(URL_VERSION+'/schoolMealsCreate?itemType=Breakfast&access_token=', JSON.stringify(mealMenu), headers).then((response) => {
            if (response.statusCode == 200) {
                this.setState({loading: false});
                this._addNotification('Successfully Created Meal Menu.');

                setTimeout(() => {
                    this.context.router.history.push('/schoolAdmin/viewMenu')
                }, 3000);
                console.log('response', response);
            } else if (!response.ok) {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({loading: false});
                this._addNotificationError(error.message);
                console.log('Meal Menu Creation Error', error.message)
            }
        );

    }


    render() {
        return (
            <div>
                <section className="mainContent full-width clearfix">
                    <NotificationSystem ref="notificationSystem"/>
                    <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    
                    <div id="print">
                        <div className="row">
                            <div className="col-xs-2">
                                <Link to="/schoolAdmin/createMenu"
                                      onClick={() => {
                                          this.props.back()
                                      }}
                                      className="btn btn-danger btn-sm pull-left " style={{margin: '0px'}}> Back</Link>
                            </div>
                            <div className="col-xs-8 text-center">
                                <h4 style={{
                                    textDecoration: 'underline',
                                    textDecorationColor: 'red',
                                    textDecorationSkip: '',
                                    color: '#0000b2',
                                    fontFamily: 'PT Serif'
                                }}>{userInfo.schoolName}</h4>
                            </div>
                            <div className="col-xs-2">
                                <button onClick={() => {this.handleCreate()}}
                                        className="btn btn-success btn-sm pull-right "
                                        style={{margin: '0px'}}> Create
                                </button>
                            </div>
                        </div>
                        <div className="text-center"><h5
                            style={{margin: '0px'}}>{MONTH[this.props.date.month - 1]} {this.props.date.year} - Breakfast Menu for Grades: {this.props.selectedGrades.join(", ")}
                        </h5></div>
                        {/* <div id='calendar'>
                        </div> */}
                        <div className="table-responsive">
                                <FullCalendar id='mCal'
                                    height="auto"
									//defaultView="listMonth"
                                    defaultDate={new Date(this.props.date.year, this.props.date.month - 1, 1)}
                                    themeSystem='bootstrap3'
                                    droppable={false}
                                    disableDragging={true}
                                    editable={false}
                                    header={false}
                                    weekends={false}
                                    editable={false}
                                    resizable={false}
                                    events={this.state.meals}
                                    displayEventTime={false}
                                    fixedWeekCount={false}
                                    // droppable: true, // this allows things to be dropped onto the calendar
                                    eventRender={this.eventRender}
                                />

                            </div>
                        <br/>
                       {/*  {
                            (this.props.meals.extra.length||0) !== 0 ?
                                <div className="text-center">
                                    <i>
                                        <b>Below items are available for on-site purchase</b>
                                    </i>
                                    <div className="row">
                                        <table className="col-xs-offset-3 col-xs-6 " border="1"
                                               style={{height: 'auto', fontWeight: 'bolder'}}>
                                            <thead style={{backgroundColor: ' #ea7066', color: 'white'}}>
                                            <tr>
                                                <th style={{textAlign: 'center'}}>Item</th>
                                                <th style={{textAlign: 'center'}}>Price</th>
                                            </tr>
                                            </thead>
                                            <tbody align="center">
                                            {
                                                this.props.meals.extra.map(meal => {
                                                    if (meal.type === "EXTRA") {
                                                        return <tr>
                                                            <td align="center">{meal.title} </td>
                                                            <td align="center"> {meal.price} </td>
                                                        </tr>;
                                                    }
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                : ''} */}
                    </div>
                    <br/>
                    <br/>
                </section>
            </div>
        )
    }
}
BreakfastCalender.contextTypes = {
    router: PropTypes.object.isRequired
}
export default BreakfastCalender;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/breakfastCalender.jsx